import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import store, { applicationActions } from '@apply/adminStore';
import { connect, useSelector } from 'react-redux';
import { ApplicationApi, FileApi } from '@apply/api';
import { applicationInsights } from '../../../ApplicationInsights';
import { FileSelectDialog } from '../../../common/SharedComponents';
import { RefreshEvents } from '../../../common/SharedEvents';
import AppraiserModal from '../../../appraisals/appraisers/modals/AppraiserModal';
import { NumericFormat } from 'react-number-format';
import { LoadPanel } from 'devextreme-react/load-panel';
import Tabs, { Item } from 'devextreme-react/tabs';
import { AppraiserSelect } from '../common/Components';
import { AppraiseStageType } from '../common/Constants';
import { PropertyStatusType, PropertyStatusTypeOptions } from '../../common/ApplicationConstants';
import List from 'devextreme-react/list';
import { ModalSummaryHeader } from '../../common/ApplicationComponents';
import { ReviewerList } from '../common/Components';
import BackSpace from '@material-ui/icons/Backspace';
import { NoticeStatusType } from '@apply/constants';
import { ConfirmModal, formatDateTime } from '@apply/ui';
import { handleAdminError, handleAdminSuccess } from '../../../common/SharedFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import DateBox from 'devextreme-react/date-box';

const CopyToModal = ({ isOpen, source, target, onCancel, onSubmit, notesOnly }) => {
    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        formRow: { marginBottom: '0' },
        buttonContainer: {
            marginRight: '10px',
            marginLeft: '10px',
            textAlign: 'right',
        },
    };

    const [selectedItems, set_selectedItems] = useState([]);
    const [openConfirmCopy, set_openConfirmCopy] = useState(false);

    useEffect(() => {
        set_selectedItems([]);
    }, [source, target]);

    const _handleClose = () => {
        onCancel && onCancel();
    };

    const submitChanges = () => {
        onSubmit && onSubmit(source.id, selectedItems);
    };

    const onSelectionChanged = (e) => {
        //Remove all Dropped items
        let tempItems = [...selectedItems];
        e.removedItems.forEach((p) => {
            const index = selectedItems.findIndex((a) => a === p.id);
            if (index > -1) {
                tempItems.splice(index, 1);
            }
        });

        //Add new items
        e.addedItems.forEach((p) => {
            const index = selectedItems.findIndex((a) => a === p.id);
            if (index < 0) {
                tempItems.push(p.id);
            }
        });

        set_selectedItems(tempItems);
    };

    const _handelConfirmCopy = () => {
        submitChanges();
    };

    const _handelCancelCopy = () => {
        set_openConfirmCopy(false);
    };

    const confirmSubmission = (e) => {
        if (selectedItems.length === 0) {
            _handleClose();
        } else {
            set_openConfirmCopy(true);
        }
    };

    const renderPropertyItem = (property) => {
        return (
            <div>
                {property.description && (
                    <div>
                        <b>
                            Property {property.bfiNumberSuffix} - {property.description}
                        </b>
                    </div>
                )}
                {property.address && (
                    <div
                        style={{
                            marginTop: '5px',
                            marginBottom: '10px',
                            fontWeight: 'bold',
                        }}
                    >
                        {property.address?.street1} {property.address?.street2} {property.address?.city},{' '}
                        {property.address?.state} {property.address?.zipCode}
                    </div>
                )}
            </div>
        );
    };

    if (!isOpen || !source || !target || target.length === 0) {
        return null;
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '450px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>Copy to...</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={_handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div
                                    className='scrollable-content'
                                    style={{ margin: '10px' }}
                                >
                                    <div className='row'>
                                        <div className='columns small-12 large-12'>
                                            <label htmlFor='propertyIds'>
                                                Copy to Properties <span className='req'>*</span>
                                            </label>
                                            <List
                                                id='propIds2'
                                                items={target}
                                                valueExpr='id'
                                                displayExpr={'bfiNumberSuffix'}
                                                showSelectionControls={true}
                                                itemRender={renderPropertyItem}
                                                placeholder='Select properties to include in the Loan'
                                                selectionMode='all'
                                                selectAllMode='page'
                                                height={200}
                                                onSelectionChanged={onSelectionChanged}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div
                                    className='button-footer'
                                    style={styles.buttonContainer}
                                >
                                    <button
                                        style={styles.buttonMarginRight}
                                        type='button'
                                        className='button primary'
                                        onClick={confirmSubmission}
                                    >
                                        Copy
                                    </button>
                                    <button
                                        type='button'
                                        className='button hollow'
                                        data-dismiss='modal'
                                        onClick={_handleClose}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <ConfirmModal
                isOpen={openConfirmCopy}
                text={
                    notesOnly
                        ? 'This will overwrite appraisal notes for the selected Properties! Are you sure?'
                        : 'This will overwrite any editable existing appraisal data for the selected Properties! Are you sure?'
                }
                confirmCallback={_handelConfirmCopy}
                cancelCallback={_handelCancelCopy}
            />
        </>
    );
};

const AppraisalModal = () => {
    const {
        isOpen,
        id,
        stage = AppraiseStageType.Order,
        readOnly = false,
        propertyId = 0,
        notesOnly = false,
    } = useSelector((state) => state.application.appraisalModal);

    const { dispatch } = store;

    const today = new Date().setHours(0, 0, 0, 0);

    const [tabIndex, set_tabIndex] = useState(-1);

    const [application, set_application] = useState(null);
    const [properties, set_properties] = useState([]);
    const [property, set_property] = useState(null);
    const [title, set_title] = useState('Order Appraisal');

    const [copyToOpen, set_copyToOpen] = useState(false);
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [loadingMessage, set_loadingMessage] = useState('Loading...');

    //File Upload
    const fileUploadOptions = {
        isOpen: false,
        maxFiles: 1,
        isReplace: false,
        typeName: '',
    };
    const [fileSelectOptions, set_fileSelectOptions] = useState(fileUploadOptions);

    const applicationApi = new ApplicationApi.ApplicationApi(applicationInsights);
    const fileApi = new FileApi.FileApi(applicationInsights);
    const refreshEvents = new RefreshEvents();

    const styles = {
        buttonMarginRight: { marginRight: '10px' },
        formRow: { marginBottom: '0' },
        buttonContainer: {
            marginRight: '10px',
            marginLeft: '10px',
            textAlign: 'right',
        },
        nonEditable: {
            backgroundColor: '#f7f7f7',
            padding: '5px',
            margin: '5px',
        },
        padding10Bottom: { marginBottom: '10px' },
        iconContainer: { paddingTop: '10px' },
        iconYes: { color: 'mediumblue', cursor: 'pointer' },
        iconNo: { color: 'silver', cursor: 'not-allowed' },
        iconCancel: { color: 'darkred', cursor: 'pointer' },
    };

    const _handleClose = () =>
        dispatch(
            applicationActions.setAppraisalModal({
                appraisalModal: { isOpen: false },
            })
        );

    useEffect(() => {
        async function isOpenChanged() {
            resetState();

            if (!isOpen || !id) {
                return;
            }

            if (readOnly) {
                set_title('View Appraisal');
            } else {
                switch (stage ?? AppraiseStageType.Order) {
                    case AppraiseStageType.Receive:
                        set_title('Receive Appraisal');
                        break;
                    case AppraiseStageType.Review:
                        set_title('Review Appraisal');
                        break;
                    default:
                        set_title('Order Appraisal');
                        break;
                }
            }

            set_tabIndex(-1);
            await loadApplication(id);
            set_loadingOpen(false);
        }

        isOpenChanged();
    }, [isOpen, id, stage]);

    useEffect(() => {
        if (!properties) {
            set_tabIndex(-1);
            return;
        }

        properties.forEach((p) => {
            if (p.expectedDate) {
                p.expectedDate = new Date(p.expectedDate);
            }
            if (p.receivedDate) {
                p.receivedDate = new Date(p.receivedDate);
            }
            if (p.appraisedDate) {
                p.appraisedDate = new Date(p.appraisedDate);
            }
        });

        if (!(tabIndex >= 0)) {
            const firstActiveIndex = properties.findIndex((p) => !p.disabled);
            set_tabIndex(firstActiveIndex);
        }
    }, [properties]);

    useEffect(() => {
        if (!properties || properties.length === 0) {
            set_property(null);
            return;
        }
        if (tabIndex < 0) {
            return;
        }
        set_property(properties[tabIndex]);
    }, [tabIndex]);

    const parseDateOnly = (dateOnly) => {
        if (!dateOnly) return null;
        const [y, m, d] = dateOnly.split('-').map(Number);
        return new Date(y, m - 1, d); // LOCAL date, no timezone shift
    };

    const loadApplication = async (id) => {
        let response = null;
        if (notesOnly) {
            response = await applicationApi.getApplicationAppraisalNotes(id);
        } else {
            let statusTypeId = null;
            switch (stage) {
                case AppraiseStageType.Order:
                    statusTypeId = PropertyStatusType.Appraise;
                    break;
                case AppraiseStageType.Receive:
                    statusTypeId = PropertyStatusType.AppraisalOrdered;
                    break;
                case AppraiseStageType.Review:
                    statusTypeId = PropertyStatusType.AppraisalReceived;
                    break;
                default:
                    return;
            }
            response = await applicationApi.getApplicationAppraisal(id, statusTypeId);
        }

        if (response.statusCode !== 200) {
            set_loadingOpen(false);
            return;
        }

        const appl = response.result;
        set_application(appl);

        appl.properties.forEach((p) => {
            // Convert DateOnly → local Date
            if (p.appraisedDate) {
                //Prevents appraised date which is a date only field from being timeshifted in devextreme component
                p.appraisedDate = parseDateOnly(p.appraisedDate);
            }
            if (propertyId && p.id !== propertyId) {
                p.disabled = true;
            } else if (readOnly) {
                p.disabled = false;
            }
        });

        set_properties(appl.properties);
        set_loadingOpen(false);
    };

    const getTargetStatus = () => {
        switch (stage) {
            case AppraiseStageType.Order:
                return PropertyStatusType.AppraisalOrdered;
            case AppraiseStageType.Receive:
                return PropertyStatusType.AppraisalReceived;
            case AppraiseStageType.Review:
                return PropertyStatusType.AppraisalReviewed;
        }
    };

    const isOkOrdered = (prop) => {
        return prop && prop.appraiserId && prop.orderedDate && prop.expectedDate && prop.cost;
    };

    const isOkReceived = (prop) => {
        return prop && prop.receivedDate && prop.appraisedValue && prop.appraisedDate;
    };

    const isOkReviewed = (prop) => {
        return prop && prop.reviewedDate && prop.reviewerId;
    };

    const canSaveProperty = (p) => {
        if (notesOnly) {
            return !p.disabled && (p.notes || (p.file && (p.file.file || p.file.url)));
        }

        switch (stage) {
            case AppraiseStageType.Order:
                return !p.disabled && isOkOrdered(p);
            case AppraiseStageType.Receive:
                return !p.disabled && isOkOrdered(p) && isOkReceived(p);
            case AppraiseStageType.Review:
                return !p.disabled && isOkOrdered(p) && isOkReceived(p) && isOkReviewed(p);
            default:
                return false;
        }
    };

    const canSubmit = () => {
        if (!properties) {
            return false;
        }

        let isOK = false;
        const propsToSave = properties.filter((p) => canSaveProperty(p));
        for (let x = 0; x < propsToSave.length; x++) {
            const prop = propsToSave[x];
            if (notesOnly) {
                if (x === 0) {
                    isOK = prop.notes || (prop.file && (prop.file.file || prop.file.url));
                } else {
                    isOK = isOK && (prop.notes || (prop.file && (prop.file.file || prop.file.url)));
                }
            } else {
                if (x === 0) {
                    isOK = isOkOrdered(prop);
                } else {
                    isOK = isOK && isOkOrdered(prop);
                }
                if (stage === AppraiseStageType.Receive) {
                    isOK = isOK && isOkReceived(prop);
                }
                if (stage === AppraiseStageType.Review) {
                    isOK = isOK && isOkReceived(prop) && isOkReviewed(prop);
                }
            }
        }
        return isOK;
    };

    const submitChanges = async (e) => {
        e.preventDefault();

        try {
            set_loadingMessage('Saving...');
            set_loadingOpen(true);
            const model = {
                id: application.id,
                properties: [],
            };

            const propsToSave = properties.filter((p) => canSaveProperty(p));

            //Upload any new Appraisal files
            set_loadingMessage(`Uploading any new appraisal files...`);
            await Promise.all(
                propsToSave.map(async (p) => {
                    const appraisalFile = p.file;
                    if (appraisalFile && appraisalFile.file) {
                        const upLoadResult = await fileApi.uploadTempFiles([appraisalFile.file]);
                        let result = upLoadResult.result;
                        if (result && result.length > 0) {
                            appraisalFile.fileName = result[0].cleanedName;
                            appraisalFile.tempFileName = result[0].tempName;
                            appraisalFile.file = null;
                        }
                    }
                })
            );

            set_loadingMessage(`Saving changes...`);
            if (notesOnly) {
                propsToSave.forEach((p) => {
                    const propModel = {
                        id: p.id,
                        notes: p.notes,
                        file: p.file,
                    };
                    model.properties.push(propModel);
                });

                const response = await applicationApi.setApplicationAppraisalNotes(id, model);
                if (response.statusCode !== 200) {
                    set_loadingOpen(false);
                    return;
                }
            } else {
                propsToSave.forEach((p) => {
                    const propModel = {
                        id: p.id,
                        statusId: getTargetStatus(),
                        appraiserId: p.appraiserId,
                        expectedDate: p.expectedDate ? new Date(p.expectedDate).toLocaleDateString('en-us') : null,
                        orderedDate: p.orderedDate ? new Date(p.orderedDate).toLocaleDateString('en-us') : null,
                        receivedDate: p.receivedDate ? new Date(p.receivedDate).toLocaleDateString('en-us') : null,
                        appraisedDate: p.appraisedDate ? new Date(p.appraisedDate).toISOString().split('T')[0] : null,
                        notes: p.notes,
                        cost: parseFloat(p.cost),
                        appraisedValue: p.appraisedValue ? parseFloat(p.appraisedValue) : null,
                        reviewedDate: p.reviewedDate ? new Date(p.reviewedDate).toLocaleDateString('en-us') : null,
                        reviewerId: p.reviewerId,
                        orderedThroughMercury: p.orderedThroughMercury,
                        file: p.file,
                    };
                    model.properties.push(propModel);
                });

                const response = await applicationApi.setApplicationAppraisal(id, model);
                if (response.statusCode !== 200) {
                    set_loadingOpen(false);
                    return;
                }
            }

            refreshEvents.dispatchRefreshEvent();

            handleAdminSuccess('Appraisal successfully saved.');
            set_loadingOpen(false);

            setTimeout(() => {
                _handleClose();
            }, 600);
        } catch (ex) {
            set_loadingOpen(false);
            handleAdminError(ex, 'An unexpected error has occurred. Please try again.');
        }
    };

    const resetState = () => {
        set_tabIndex(-1);
        set_application(null);
        set_properties([]);
        set_properties(null);
    };

    const onTabsSelectionChanged = (args) => {
        if (args.name === 'selectedIndex') {
            let ti = args.value;
            if (args.value >= 0) {
                var prop = properties[ti];
                if (prop.disabled) {
                    ti = properties.findIndex((p) => !p.disabled);
                }
            }
            set_tabIndex(ti);
        }
    };

    const onPropertyAppraiserSelect = (id, apprId) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.appraiserId = apprId;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setOrderedDate = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.orderedDate = value;
        if (!propToUpdate.expectedDate) {
            const newDate = new Date(value);
            propToUpdate.expectedDate = newDate.setDate(newDate.getDate() + 14);
        }
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setExpectedDate = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.expectedDate = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setReceivedDate = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.receivedDate = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setAppraisedDate = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.appraisedDate = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setAppraisedValue = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.appraisedValue = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setCost = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.cost = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setNotes = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.notes = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setReviewedDate = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.reviewedDate = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setReviewerId = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.reviewerId = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setOrderedThroughMercury = (id, value) => {
        var propToUpdate = properties.find((p) => p.id === id);
        propToUpdate.orderedThroughMercury = value;
        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const setFileIsFinal = (id, isFinal) => {
        var propToUpdate = properties.find((p) => p.id === id);
        if (property.file) {
            propToUpdate.file.isFinal = isFinal;
            var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
            set_properties(newProperties);
        }
    };

    const canCopyTo = (prop) => {
        if (!prop) {
            return false;
        }

        const targets = properties.filter((p) => p.id !== prop.id);
        return targets.length > 0 && canSaveProperty(prop);
    };

    const showCopyToModal = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        set_copyToOpen(true);
    };

    const copyToCancel = () => {
        set_copyToOpen(false);
    };

    const copyToSubmit = (sourceId, targetIds) => {
        if (targetIds.length === 0) {
            return;
        }

        const source = properties.find((p) => p.id === sourceId);
        const newProperties = [];
        properties.forEach((p) => {
            //If in the targetIds copy everything over
            if (targetIds.includes(p.id)) {
                if (!notesOnly) {
                    p.appraiserId = source.appraiserId;
                    p.orderedDate = source.orderedDate;
                    p.expectedDate = source.expectedDate;
                    p.cost = source.cost;
                    p.receivedDate = source.receivedDate;
                    p.appraisedVale = source.appraisedValue;
                    p.appraisedDate = source.appraisedDate;
                    p.reviewerId = source.reviewerId;
                    p.reviewedDate = source.reviewedDate;
                    p.orderedThroughMercury = source.orderedThroughMercury;
                }
                p.notes = source.notes;
            }
            newProperties.push(p);
        });
        set_properties(properties);

        set_copyToOpen(false);
    };

    const uploadFile = (e, propertyId) => {
        e.preventDefault();
        e.stopPropagation();

        const options = {
            ownerId: propertyId,
            isOpen: true,
            maxFiles: 1,
            isReplace: true,
            fileTypeName: 'Appraisal',
        };
        set_fileSelectOptions(options);
    };

    const onFileSelectSubmit = (propertyId, filesToUpload) => {
        var propToUpdate = properties.find((p) => p.id === propertyId);

        if (!filesToUpload || filesToUpload.length === 0) {
            _onRemoveTempFile();
            set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
            return;
        }

        let fileToUpdate = propToUpdate.file;
        if (!fileToUpdate) {
            fileToUpdate = {};
            propToUpdate.file = fileToUpdate;
        }

        fileToUpdate.file = filesToUpload[0];
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });

        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const onFileSelectCancel = () => {
        set_fileSelectOptions({ ...fileSelectOptions, isOpen: false });
    };

    const _onRemoveTempFile = (propertyId) => {
        var propToUpdate = properties.find((p) => p.id === propertyId);
        const fileToUpdate = propToUpdate.file;
        if (!fileToUpdate) {
            return;
        }

        fileToUpdate.file = null;
        if (!fileToUpdate.id) {
            propToUpdate.file = null;
        }

        var newProperties = properties.map((p) => (p.id !== propToUpdate.id ? p : propToUpdate));
        set_properties(newProperties);
    };

    const getNoticeStyle = (property) => {
        switch (property.appraisalReportNoticeStatusId) {
            case NoticeStatusType.Emailed:
            case NoticeStatusType.Generated:
                return { paddingTop: '8px', color: 'green' };
            case NoticeStatusType.Pending:
                if (!(property?.file?.isFinal ?? false)) {
                    return { paddingTop: '8px', color: 'gray' };
                } else {
                    return { paddingTop: '8px', color: 'darkred' };
                }
            case NoticeStatusType.Error:
                return { paddingTop: '8px', color: 'darkred' };
            default:
                if (!(property?.file?.oldIsFinal ?? false) && (property?.file?.isFinal ?? false)) {
                    return { paddingTop: '8px', color: 'darkred' };
                } else {
                    return { paddingTop: '8px', color: 'gray' };
                }
        }
    };

    const getNoticeTitle = (property) => {
        switch (property.appraisalReportNoticeStatusId) {
            case NoticeStatusType.Emailed:
                return `The notice 'Appraisal Report' was sent at ${formatDateTime(property.appraisalReportNoticeDate)}`;
            case NoticeStatusType.Generated:
                return `The notice 'Appraisal Report' has been generated but not yet emailed`;
            case NoticeStatusType.Pending:
                if (!(property?.file?.isFinal ?? false)) {
                    return "The notice 'Appraisal Report' will be unscheduled";
                } else {
                    return `The notice 'Appraisal Report' will be sent at ${formatDateTime(property.appraisalReportNoticeDate)}`;
                }
            case NoticeStatusType.Error:
                return "The notice 'Appraisal Report' experiences an Error";
            default:
                if (!(property?.file?.oldIsFinal ?? false) && (property?.file?.isFinal ?? false)) {
                    return "The notice 'Appraisal Report' will be scheduled to be sent after Save";
                }
                return 'Current changes will not trigger a notice.';
        }
    };

    if (!isOpen || !application) {
        return null;
    }

    return (
        <>
            <Dialog
                maxWidth='sm'
                open={isOpen}
                onClose={_handleClose}
                aria-labelledby='form-dialog-title'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            tabIndex='-1'
                            role='dialog'
                            style={{ width: '720px' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <form
                                    name='orderAppraisalForm'
                                    onSubmit={(event) => submitChanges(event)}
                                >
                                    <div
                                        className='page-header'
                                        role='banner'
                                    >
                                        <h1>{title}</h1>
                                        <button
                                            type='button'
                                            className='close'
                                            data-dismiss='modal'
                                            aria-label='Close'
                                            onClick={_handleClose}
                                        >
                                            <span aria-hidden='true'>&times;</span>
                                        </button>
                                    </div>
                                    <ModalSummaryHeader application={application} />
                                    <div
                                        className='scrollable-content'
                                        style={{ margin: '10px' }}
                                    >
                                        <div className={'standard-form'}>
                                            <h2 className='decorated'>{properties?.length > 1 ? 'Properties' : 'Property'}</h2>
                                            <div>
                                                {application.isPortfolio && (
                                                    <Tabs
                                                        showNavButtons={true}
                                                        width={'80%'}
                                                        selectedIndex={tabIndex}
                                                        onOptionChanged={onTabsSelectionChanged}
                                                    >
                                                        {application.properties.map((p) => {
                                                            return (
                                                                <Item
                                                                    key={'tab' + p.id}
                                                                    text={'Prop ' + p.bfiNumberSuffix}
                                                                    disabled={p.disabled}
                                                                />
                                                            );
                                                        })}
                                                    </Tabs>
                                                )}
                                                {property && (
                                                    <div
                                                        style={{
                                                            border: '1px solid silver',
                                                            padding: '5px',
                                                            marginBottom: '10px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                minHeight: '480px',
                                                            }}
                                                        >
                                                            <div className='row'>
                                                                <div
                                                                    className='columns small-12 large-12'
                                                                    style={styles.nonEditable}
                                                                >
                                                                    {property.description && (
                                                                        <div>
                                                                            <b>
                                                                                Property {property.bfiNumberSuffix} -{' '}
                                                                                {property.description}
                                                                            </b>
                                                                        </div>
                                                                    )}
                                                                    {property.address && (
                                                                        <div
                                                                            style={{
                                                                                marginTop: '5px',
                                                                                marginBottom: '10px',
                                                                                fontWeight: 'bold',
                                                                            }}
                                                                        >
                                                                            {property.address?.street1}{' '}
                                                                            {property.address?.street2} {property.address?.city},{' '}
                                                                            {property.address?.state} {property.address?.zipCode}
                                                                        </div>
                                                                    )}
                                                                    {property.statusId && (
                                                                        <div
                                                                            style={{
                                                                                marginTop: '5px',
                                                                                marginBottom: '10px',
                                                                            }}
                                                                        >
                                                                            Status:{' '}
                                                                            <b
                                                                                style={{
                                                                                    color: 'darkblue',
                                                                                }}
                                                                            >
                                                                                {
                                                                                    PropertyStatusTypeOptions.find(
                                                                                        (p) => p.id === property.statusId
                                                                                    ).name
                                                                                }
                                                                            </b>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <h2 className='decorated'>Appraisal</h2>
                                                            <AppraiserSelect
                                                                id={'as_' + property.id}
                                                                onSelect={(apprId) =>
                                                                    onPropertyAppraiserSelect(property.id, apprId)
                                                                }
                                                                appraiserId={property?.appraiserId}
                                                                disabled={readOnly || notesOnly}
                                                                canEdit={!readOnly && !notesOnly}
                                                            />
                                                            <div
                                                                className='row'
                                                                style={styles.formRow}
                                                            >
                                                                <div className='columns small-12 large-3'>
                                                                    <label htmlFor='orderedDate'>
                                                                        Ordered Date <span className='req'>*</span>
                                                                    </label>
                                                                    <DateBox
                                                                        id={'orderedDate' + property.id}
                                                                        value={
                                                                            property?.orderedDate
                                                                                ? new Date(property.orderedDate)
                                                                                : null
                                                                        }
                                                                        onValueChange={(value) =>
                                                                            setOrderedDate(property.id, value)
                                                                        }
                                                                        max={today}
                                                                        disabled={readOnly || notesOnly}
                                                                        required={true}
                                                                    />
                                                                </div>
                                                                <div className='columns small-12 large-3'>
                                                                    <label htmlFor='expectedDate'>
                                                                        Expected Date <span className='req'>*</span>
                                                                    </label>
                                                                    <DateBox
                                                                        id={'expectedDate' + property.id}
                                                                        value={
                                                                            property?.expectedDate
                                                                                ? new Date(property.expectedDate)
                                                                                : null
                                                                        }
                                                                        onValueChange={(value) =>
                                                                            setExpectedDate(property.id, value)
                                                                        }
                                                                        min={property?.orderedDate}
                                                                        disabled={readOnly || notesOnly}
                                                                        required={true}
                                                                    />
                                                                </div>

                                                                <div className='columns small-12 large-3'>
                                                                    <label htmlFor='cost'>
                                                                        Cost <span className='req'>*</span>
                                                                    </label>
                                                                    <NumericFormat
                                                                        thousandSeparator=','
                                                                        prefix='$'
                                                                        id={'cost' + property.id}
                                                                        placeholder='$'
                                                                        value={property?.cost ?? ''}
                                                                        decimalScale={2}
                                                                        allowNegative={false}
                                                                        onValueChange={(values) => {
                                                                            setCost(property.id, values.floatValue);
                                                                        }}
                                                                        required={true}
                                                                        isAllowed={(values, sourceInfo) => {
                                                                            const value = values?.floatValue;
                                                                            return (
                                                                                value === undefined || value === null || value > 0
                                                                            );
                                                                        }}
                                                                        disabled={readOnly || notesOnly}
                                                                    />
                                                                </div>

                                                                {stage > AppraiseStageType.Order && (
                                                                    <>
                                                                        <div className='columns small-12 large-3'>
                                                                            <label htmlFor='receivedDate'>
                                                                                Received Date <span className='req'>*</span>
                                                                            </label>
                                                                            <DateBox
                                                                                id={'receivedDate' + property.id}
                                                                                value={
                                                                                    property?.receivedDate
                                                                                        ? new Date(property.receivedDate)
                                                                                        : null
                                                                                }
                                                                                onValueChange={(value) =>
                                                                                    setReceivedDate(property.id, value)
                                                                                }
                                                                                min={property.orderedDate}
                                                                                max={today}
                                                                                disabled={readOnly || notesOnly}
                                                                                required={true}
                                                                            />
                                                                        </div>
                                                                        <div className='columns small-12 large-3'>
                                                                            <label htmlFor='appraisedDate'>
                                                                                Appraise Date <span className='req'>*</span>
                                                                            </label>
                                                                            <DateBox
                                                                                id={'appraisedDate' + property.id}
                                                                                value={
                                                                                    property?.appraisedDate
                                                                                        ? new Date(property.appraisedDate)
                                                                                        : null
                                                                                }
                                                                                onValueChange={(value) =>
                                                                                    setAppraisedDate(property.id, value)
                                                                                }
                                                                                min={property.orderedDate}
                                                                                max={today}
                                                                                disabled={readOnly || notesOnly}
                                                                                required={true}
                                                                            />
                                                                        </div>
                                                                        <div className='columns small-12 large-3'>
                                                                            <label htmlFor='appraisedValue'>
                                                                                Appraise Value <span className='req'>*</span>
                                                                            </label>
                                                                            <NumericFormat
                                                                                thousandSeparator=','
                                                                                prefix='$'
                                                                                id={'appraisedValue' + property.id}
                                                                                placeholder='$'
                                                                                value={property?.appraisedValue ?? ''}
                                                                                decimalScale={2}
                                                                                allowNegative={false}
                                                                                onValueChange={(values) => {
                                                                                    setAppraisedValue(
                                                                                        property.id,
                                                                                        values.floatValue
                                                                                    );
                                                                                }}
                                                                                required={true}
                                                                                isAllowed={(values, sourceInfo) => {
                                                                                    const value = values?.floatValue;
                                                                                    return (
                                                                                        value === undefined ||
                                                                                        value === null ||
                                                                                        value > 0
                                                                                    );
                                                                                }}
                                                                                disabled={readOnly || notesOnly}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div className='columns small-12 medium-6'>
                                                                    <input
                                                                        id={'orderedThroughMercury' + property.id}
                                                                        checked={property?.orderedThroughMercury === true}
                                                                        onChange={(event) =>
                                                                            setOrderedThroughMercury(
                                                                                property.id,
                                                                                event.target.checked
                                                                            )
                                                                        }
                                                                        type='checkbox'
                                                                    />
                                                                    <label htmlFor={'orderedThroughMercury' + property.id}>
                                                                        Ordered Through Mercury
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            {stage > AppraiseStageType.Receive && (
                                                                <div
                                                                    className='row'
                                                                    style={styles.formRow}
                                                                >
                                                                    <div className='columns small-12 large-3'>
                                                                        <label htmlFor={'reviewedDate' + property.id}>
                                                                            Reviewed Date <span className='req'>*</span>
                                                                        </label>
                                                                        <DateBox
                                                                            id={'reviewedDate' + property.id}
                                                                            value={
                                                                                property?.reviewedDate
                                                                                    ? new Date(property.reviewedDate)
                                                                                    : null
                                                                            }
                                                                            onValueChange={(value) =>
                                                                                setReviewedDate(property.id, value)
                                                                            }
                                                                            min={property.receivedDate}
                                                                            disabled={readOnly || notesOnly}
                                                                            required={true}
                                                                        />
                                                                    </div>
                                                                    <ReviewerList
                                                                        reviewerId={property?.reviewerId}
                                                                        onChange={(newId) => setReviewerId(property.id, newId)}
                                                                        disabled={readOnly || notesOnly}
                                                                        required={true}
                                                                    />
                                                                </div>
                                                            )}

                                                            {(property.statusId > PropertyStatusType.AppraisalOrdered ||
                                                                stage > AppraiseStageType.Order) && (
                                                                <>
                                                                    <div
                                                                        className='row'
                                                                        style={styles.formRow}
                                                                    >
                                                                        <div
                                                                            className='columns small-12 large-12'
                                                                            style={{
                                                                                paddingTop: '10px',
                                                                            }}
                                                                        >
                                                                            {property.file && (
                                                                                <span>
                                                                                    {property.file.file ? (
                                                                                        <span>
                                                                                            {property.file.file.name}{' '}
                                                                                            &nbsp;&nbsp;&nbsp;
                                                                                        </span>
                                                                                    ) : property.file.url ? (
                                                                                        <a
                                                                                            href={property.file.url}
                                                                                            target='_blank'
                                                                                            rel='noreferrer'
                                                                                        >
                                                                                            {property.file.fileName}{' '}
                                                                                            &nbsp;&nbsp;&nbsp;
                                                                                        </a>
                                                                                    ) : null}
                                                                                    <select
                                                                                        style={{
                                                                                            width: '150px',
                                                                                        }}
                                                                                        value={property.file.isFinal ? '1' : '0'}
                                                                                        onChange={(e) =>
                                                                                            setFileIsFinal(
                                                                                                property.id,
                                                                                                e.target.value === '1'
                                                                                            )
                                                                                        }
                                                                                        required
                                                                                        disabled={
                                                                                            readOnly ||
                                                                                            (!property.file.url &&
                                                                                                !property.file.file)
                                                                                        }
                                                                                    >
                                                                                        <option value='0'>Draft</option>
                                                                                        <option value='1'>Final</option>
                                                                                    </select>
                                                                                    &nbsp;&nbsp;
                                                                                    <span
                                                                                        style={{
                                                                                            verticalAlign: 'middle',
                                                                                        }}
                                                                                    >
                                                                                        {property.file.url && (
                                                                                            <>
                                                                                                <a
                                                                                                    href={property.file.url}
                                                                                                    target='_blank'
                                                                                                    rel='noreferrer'
                                                                                                    title='Download the file'
                                                                                                >
                                                                                                    <FontAwesomeIcon
                                                                                                        icon={faDownload}
                                                                                                        style={styles.iconYes}
                                                                                                    />
                                                                                                </a>
                                                                                                &nbsp;&nbsp;
                                                                                            </>
                                                                                        )}
                                                                                        {property.file.file && (
                                                                                            <>
                                                                                                <BackSpace
                                                                                                    style={styles.iconCancel}
                                                                                                    onClick={() => {
                                                                                                        _onRemoveTempFile(
                                                                                                            property.id
                                                                                                        );
                                                                                                    }}
                                                                                                    title='Cancel Upload'
                                                                                                />
                                                                                                &nbsp;&nbsp;
                                                                                            </>
                                                                                        )}
                                                                                    </span>
                                                                                </span>
                                                                            )}

                                                                            <button
                                                                                type='button'
                                                                                className='button hollow'
                                                                                data-dismiss='modal'
                                                                                onClick={(e) => uploadFile(e, property.id)}
                                                                                style={{
                                                                                    height: '25px',
                                                                                    marginTop: '12px',
                                                                                }}
                                                                                disabled={readOnly}
                                                                            >
                                                                                {property.file?.url ? (
                                                                                    <span>Replace File</span>
                                                                                ) : (
                                                                                    <span>Upload File</span>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    {property.file && (
                                                                        <div
                                                                            className='row'
                                                                            style={styles.formRow}
                                                                        >
                                                                            <div
                                                                                className='columns small-12 large-12'
                                                                                style={{
                                                                                    paddingTop: '10px',
                                                                                }}
                                                                            >
                                                                                <span
                                                                                    className='columns small-12 large-4'
                                                                                    style={getNoticeStyle(property)}
                                                                                >
                                                                                    <i title={getNoticeTitle(property)}>
                                                                                        <FontAwesomeIcon icon={faEnvelope} />
                                                                                    </i>
                                                                                    &nbsp;&nbsp;
                                                                                    {getNoticeTitle(property)}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}

                                                            {stage >= AppraiseStageType.Order && (
                                                                <div
                                                                    className='row'
                                                                    style={styles.formRow}
                                                                >
                                                                    <div className='columns small-12 large-12'>
                                                                        <label htmlFor='notes'>Notes:</label>
                                                                        <textarea
                                                                            id={'notes' + property.id}
                                                                            cols={40}
                                                                            rows={4}
                                                                            maxLength={2000}
                                                                            className='req'
                                                                            value={property?.notes ?? ''}
                                                                            onChange={(e) =>
                                                                                setNotes(property.id, e.target.value)
                                                                            }
                                                                            disabled={readOnly}
                                                                            placeholder='Enter relevant appraisal notes...'
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {application.isPortfolio && (
                                                                <div
                                                                    className='row'
                                                                    style={styles.formRow}
                                                                >
                                                                    <div
                                                                        className='columns small-12 large-12'
                                                                        style={{
                                                                            paddingBottom: '0',
                                                                            textAlign: 'right',
                                                                        }}
                                                                    >
                                                                        <button
                                                                            type='button'
                                                                            className='button hollow'
                                                                            data-dismiss='modal'
                                                                            onClick={(e) => showCopyToModal(e, property.id)}
                                                                            title='Copy all updated appraisal details to other eligible properties'
                                                                            disabled={
                                                                                readOnly || propertyId || !canCopyTo(property)
                                                                            }
                                                                        >
                                                                            Copy To...
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        className='button-footer'
                                        style={styles.buttonContainer}
                                    >
                                        {!readOnly && (
                                            <button
                                                style={styles.buttonMarginRight}
                                                type='submit'
                                                className='button primary'
                                                disabled={!canSubmit()}
                                            >
                                                Submit
                                            </button>
                                        )}
                                        <button
                                            type='button'
                                            className='button hollow'
                                            data-dismiss='modal'
                                            onClick={_handleClose}
                                        >
                                            {readOnly ? 'Close' : 'Cancel'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <AppraiserModal />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
            <CopyToModal
                isOpen={copyToOpen}
                source={property}
                target={properties?.filter((p) => p.id !== property?.id && !p.disabled)}
                onCancel={copyToCancel}
                onSubmit={copyToSubmit}
                notesOnly={notesOnly}
            />
            <FileSelectDialog
                options={fileSelectOptions}
                onSubmit={onFileSelectSubmit}
                onCancel={onFileSelectCancel}
            />
        </>
    );
};

export default AppraisalModal;
